import { Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthenticationService } from '../authentication.service';

import { CountersService } from '../counters.service';

import { FirestoreService } from './firestore.service';

interface CounterDto {
    value: number;
}

@Injectable()
export class FirestoreCountersService extends CountersService {
    constructor(private authenticationService: AuthenticationService, private firestore: FirestoreService) {
        super();
    }

    counter(key: string): Observable<number> {
        return this.firestore
            .tenantDependentCollection(this.authenticationService.user.tenantId, 'counters')
            .doc<CounterDto>(key)
            .valueChanges()
            .pipe(
                catchError(() => of({ value: 0 })),
                map((res) => (res ? res.value : 0))
            );
    }
}
